import React, { useEffect, useState } from "react";
import { Button, Box, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Chip, TextField, Typography } from '@mui/material';
import ExclusiveSelection from './ExclusiveSelection'
import PriceRangeSelector from "./PriceRangeSelector";
import SaveSearchModal from './SaveSearchModal';
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { getProtectedResource } from "../utils/api";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { CenterFocusStrong, Margin } from "@mui/icons-material";
import logo from "../Assets/ASPC logo.png"

const sortOptions = [
    { label: 'Most Recent', key: 'Recent' },
    { label: 'Price Low to High', key: 'LowHigh' },
    { label: 'Price High to Low', key: 'HighLow' },
    { label: 'm² - ↓', key: 'AreaDesc' },
    { label: 'm² - ↑', key: 'AreaAsc' },
    { label: '£/m² - ↑', key: 'PricePerAreaAsc' },
    { label: '£/m² - ↓', key: 'PricePerAreaDesc' }
];

const FilterPanel = ({
    statusCategory,
    Beds,
    Baths,
    priceRange,
    handleCategoryChange,
    typeCategory,
    handleTypeChange,
    locationCategory,
    pSchoolCategory,
    handleLocationChange,
    handlePschoolChange,
    handlePriceChange,
    FloorArea,
    handleAreaChange,
    handleExclusiveSelectionChange,
    handlebathChange,
    handleApplyFilter,
    handleSortChange,
    sortOption,
    Categorys,
    Types,
    locations,
    PrimarySchools,
    ITEM_HEIGHT,
    ITEM_PADDING_TOP,
    MenuProps,
    handleSaveSearch,
    items }) => {


    const [loginOpen, setLoginOpen] = useState(false);
    const [signupOpen, setSignupOpen] = useState(false);
    const { loginWithRedirect } = useAuth0();
    const [modalOpen, setModalOpen] = useState(false);
    const [filtersVisible, setFiltersVisible] = useState(false);

    const loginclick = async (event) => {
        event.preventDefault();
        loginWithRedirect()
    }



    const toggleLogin = () => {
        setLoginOpen(prev => !prev)
        console.log("login is " + loginOpen)
    };
    const toggleSignup = () => {

        setSignupOpen(prev => !prev)
        console.log("signup is " + signupOpen)

    };

    const handlefilterpanel = () => {
        setFiltersVisible(prev => !prev);
    };

    return (
        <div className="filterPanel">
            <div className="row" style={{ justifyContent: "space-between", height: "50px", background: "white" }}>
                <div className="logoWrapper" style={{marginLeft:"150px"}}>
                    <img className="ASPCimg" src={logo}></img>
                    <h1 className="ASPCtext" >ASPC</h1>
                </div>


                <div className='SignupWrapper' style={{marginRight:"150px"}} onClick={loginclick}>

                    <AccountCircleIcon style={{ color: "#1976d2", fontSize: "2.15rem" }} /> {/* Icon component */}
                    <span className="myAccountText" >My Account</span> {/* Text next to icon */}
                </div>
            </div>
            <div className="row" style={{ justifyContent: "center", background: "#262637", alignItems: "center" }}>
                <div className="headerbarWrapper">
                    <FormControl
                        variant="outlined"
                        sx={{
                            backgroundColor: 'white',
                            marginY: '5px',
                            height: 40,
                            width: 300,
                            borderRadius: '8px',
                            '.MuiOutlinedInput-root': {
                                height: 40,
                                width: 300,
                                borderRadius: '8px',
                            },
                            '.MuiOutlinedInput-input': {
                                height: 40,
                                lineHeight: '40px',
                                width: 300,
                                paddingLeft: '5px', // Padding for input
                                display: "flex"
                            },
                        }}
                    >
                        <Select
                            id="location-multiple-chip"
                            multiple
                            value={locationCategory}
                            onChange={handleLocationChange}
                            input={<OutlinedInput />}
                            displayEmpty
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return (
                                        <span style={{ color: '#aaa', paddingLeft: '5px' }}>Select a location</span>
                                    ); // Placeholder with left padding
                                }
                                return (
                                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={locations.find(location => location.value === value)?.label} />
                                        ))}
                                    </Box>
                                );
                            }}
                            MenuProps={MenuProps}
                            sx={{
                                borderRadius: '8px',
                            }}
                        >
                            {locations.map((location) => (
                                <MenuItem key={location.value} value={location.value}>
                                    {location.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>






                    <PriceRangeSelector onPriceChange={handlePriceChange} ></PriceRangeSelector>

                    <FormControl
                        variant="outlined"
                        className="formControl3"
                        sx={{
                            backgroundColor: 'white',
                            height: 40,
                            borderRadius: '8px',
                            width:200,
                            '.MuiOutlinedInput-root': {
                                height: 40,
                                borderRadius: '8px',
                            },
                            '.MuiOutlinedInput-input': {
                                height: 40,
                                lineHeight: '40px',
                                paddingLeft: '5px',
                                display: 'flex',
                            },
                        }}
                    >
                        <TextField
                            variant="outlined"
                            fullWidth
                            value={FloorArea !== '' ? `${FloorArea} m²` : ''}
                            onChange={(event) => {
                                const rawValue = event.target.value.replace(/[^\d]/g, ''); // Strip non-numeric characters
                                event.target.value = rawValue; // Update the event to reflect numeric value
                                handleAreaChange(event); // Pass the event to the parent handler
                            }}
                            type="text"
                            placeholder="Floor Area (min)"
                            InputProps={{
                                inputProps: {
                                    min: 0,
                                },
                            }}
                            className="FloorArea-range-text-field"
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="formControl"
                        sx={{
                            backgroundColor: 'white',
                            marginY: '5px',
                            height: 40,
                            width: 335,
                            borderRadius: '8px',
                            '.MuiOutlinedInput-root': {
                                height: 40,
                                borderRadius: '8px',
                            },
                            '.MuiOutlinedInput-input': {
                                height: 40,
                                lineHeight: '40px',
                                paddingLeft: '5px', // Padding for input
                                display: "flex"
                            },
                        }}
                    >

                        <Select
                            labelId="type-multiple-chip-label"
                            id="type-multiple-chip"
                            multiple
                            value={typeCategory} // This should be an array to support multiple selections
                            onChange={handleTypeChange} // Update to handle multiple selections
                            input={<OutlinedInput />} // Ensure the label is passed here for proper alignment
                            displayEmpty
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return (
                                        <span style={{ color: '#aaa', paddingLeft: '5px' }}>Type</span>
                                    ); // Placeholder with left padding
                                }
                                return (
                                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                                        {selected.map((value) => {
                                            const formattedValue = value
                                                .replace(/^feature-/, '') // Remove the "feature-" prefix
                                                .replace(/-/g, ' ') // Replace "-" with spaces
                                                .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                            return <Chip key={value} label={formattedValue} />;
                                        })}
                                    </Box>
                                );
                            }}
                            MenuProps={MenuProps}
                            >
                                {Types.map((Type) => {
                                    const formattedLabel = Type.label
                                        .replace(/^feature-/, '') // Remove the "feature-" prefix
                                        .replace(/-/g, ' ') // Replace "-" with spaces
                                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                            
                                    return (
                                        <MenuItem key={Type.value} value={Type.value}>
                                            {formattedLabel}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>





                    <div className="buttonGroup">


                        <Button style={{ marginTop: "0px" }} onClick={handlefilterpanel} className="ShowFiltersButton" variant="contained">{filtersVisible ? 'Filters 🔼' : 'Filters 🔽'}</Button>
                        <SaveSearchModal
                            handleSaveSearch={handleSaveSearch}
                            isOpen={modalOpen}
                            onClose={() => setModalOpen(false)} />
                    </div>
                </div>

            </div>

            <div className="row" style={{
                justifyContent: "center",
                background: "white",
                transition: "transform 0.3s ease-in-out",
                transform: filtersVisible ? "translateY(0)" : "translateY(-100%)",
                overflow: "hidden",
                position: "relative",
                zIndex: -1

            }}>
                <div className="headerbarWrapper">
                    <FormControl variant="outlined" className="formControl2"
                        sx={{
                            backgroundColor: 'white',
                            marginTop: "auto",
                            marginBottom: "auto",
                            height: 40,
                            width: 300,
                            borderRadius: '8px',
                            '.MuiOutlinedInput-root': {
                                height: 40,
                                width: 300,
                                borderRadius: '8px',
                            },
                            '.MuiOutlinedInput-input': {
                                height: 40,
                                lineHeight: '40px',
                                width: 300,
                                paddingLeft: '5px', // Padding for input
                                display: "flex"
                            },
                        }}
                    >
                        <Select
                            labelId="Pschool-multiple-chip-label"
                            id="Pschool-multiple-chip"
                            multiple
                            value={pSchoolCategory}
                            onChange={handlePschoolChange}
                            input={<OutlinedInput />} // Ensure the label is passed here for proper alignment
                            displayEmpty
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return (
                                        <span style={{ color: '#aaa', paddingLeft: '5px' }}>Select Primary School</span>
                                    ); // Placeholder with left padding
                                }
                                return (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={PrimarySchools.find(PrimarySchools => PrimarySchools.value === value)?.label} />
                                        ))}
                                    </Box>
                                );
                            }}
                            MenuProps={MenuProps}
                        >
                            {PrimarySchools.map((PrimarySchools) => (
                                <MenuItem key={PrimarySchools.value} value={PrimarySchools.value}>
                                    {PrimarySchools.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl variant="outlined" className="formControl4"
                        sx={{
                            marginLeft:"20px",
                            backgroundColor: 'white',
                            marginTop: "auto",
                            marginBottom: "auto",
                            height: 40,
                            width: 262,
                            borderRadius: '8px',
                            '.MuiOutlinedInput-root': {
                                height: 40,
                                width: 262,
                                borderRadius: '8px',
                            },
                            '.MuiOutlinedInput-input': {
                                height: 40,
                                lineHeight: '40px',
                                width: 262,
                                paddingLeft: '5px', // Padding for input
                                display: "flex"
                            },
                        }}
                    >
                        <Select
                            labelId="Hschool-multiple-chip-label"
                            id="Hschool-multiple-chip"
                            multiple
                            value={pSchoolCategory}
                            onChange={handlePschoolChange}
                            input={<OutlinedInput />} // Ensure the label is passed here for proper alignment
                            displayEmpty
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return (
                                        <span style={{ color: '#aaa', paddingLeft: '5px' }}>Select Highschool School</span>
                                    ); // Placeholder with left padding
                                }
                                return (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={PrimarySchools.find(PrimarySchools => PrimarySchools.value === value)?.label} />
                                        ))}
                                    </Box>
                                );
                            }}
                            MenuProps={MenuProps}
                        >
                            {PrimarySchools.map((PrimarySchools) => (
                                <MenuItem key={PrimarySchools.value} value={PrimarySchools.value}>
                                    {PrimarySchools.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl variant="outlined" className="formControl"
                        sx={{
                            backgroundColor: 'white',
                            marginY: 'auto',
                            height: 40,
                            width: 200,
                            borderRadius: '8px',

                            '.MuiOutlinedInput-root': {
                                height: 40,
                                borderRadius: '8px',
                            },
                            '.MuiOutlinedInput-input': {
                                height: 40,
                                lineHeight: '40px',
                                paddingLeft: '5px', // Padding for input
                                display: "flex"
                            },
                        }}
                    >

                        <Select
                            labelId="show-multiple-chip-label"
                            id="show-multiple-chip"
                            multiple
                            value={statusCategory} // This should be an array to support multiple selections
                            onChange={handleCategoryChange} // Update to handle multiple selections
                            input={<OutlinedInput />} // Ensure the label is passed here for proper alignment
                            displayEmpty
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return (
                                        <span style={{ color: '#aaa', paddingLeft: '5px' }}>Status</span>
                                    ); // Placeholder with left padding
                                }
                                return (
                                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={Categorys.find(Categorys => Categorys.value === value)?.label} />
                                        ))}
                                    </Box>
                                );
                            }}
                            MenuProps={MenuProps}
                        >
                            {Categorys.map((Category) => (
                                <MenuItem key={Category.value} value={Category.value}>
                                    {Category.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>


                    <ExclusiveSelection label="Beds" onSelectionChange={handleExclusiveSelectionChange} />

                    <ExclusiveSelection label="Bathrooms" onSelectionChange={handlebathChange} />


                    <Button style={{ marginTop: "auto", marginBottom: "auto" }} onClick={handleApplyFilter} className="ApplyButton" variant="contained">Apply Filter</Button>


                </div>
            </div>

            <div className="row" style={{
                justifyContent: "center",
                background: "white",
                borderTop: "1px lightgrey solid",
                transition: "transform 0.3s ease-in-out",
                transform: filtersVisible ? "translateY(0px)" : "translateY(-95px)", // Move the 4th row when the 3rd slides in
                position: "relative"
            }}>
                <div className="headerbarWrapper" style={{ justifyContent: "flex-start", marginTop: "9px", marginBottom: "8px"}}>
                    {/* Constructing dynamic text */}
                    <div style={{ fontWeight: 500 }}>
                        Properties for Sale in {
                            locationCategory.length > 0
                                ? locationCategory.map(loc => locations.find(location => location.value === loc)?.label).join(', ')
                                : pSchoolCategory.length > 0
                                    ? pSchoolCategory.map(school => PrimarySchools.find(primary => primary.value === school)?.label).join(', ')
                                    : 'All Areas'
                        },
                          {FloorArea && FloorArea > 0 ? `with at least ${FloorArea} m²` : 'of any size'},
                        including {Beds || 'any number of'} Bedrooms ➡️
                    </div>
                    <Button
                        style={{ marginTop: "auto", marginBottom: "auto", backgroundColor: "#bbdabb" }}
                        onClick={() => setModalOpen(true)}
                        className="SaveSearchButton"
                        variant="contained"
                    >
                        Save Search
                    </Button>
                </div>
            </div>

            <div className="row" style={{
                justifyContent: "center",

                background: "white",
                borderTop: "1px lightgrey solid",
                transition: "transform 0.3s ease-in-out",
                transform: filtersVisible ? "translateY(0px)" : "translateY(-95px)", // Move the 4th row when the 3rd slides in
                position: "relative",

            }}>
                <div className="headerbarWrapper" style={{ justifyContent: "flex-start" }}>
                    <div className="oftotal">{items} Results</div>

                    

                    <FormControl className="Sort-Dropdown"
                        sx={{
                            backgroundColor: 'white',
                            height: 30,
                            marginTop: "5px",
                            marginBottom: "5px",
                            borderRadius: '8px',
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            width: "165px",
                            '.MuiOutlinedInput-root': {
                                height: 30,
                                borderRadius: '8px',
                                width: "165px",

                            },
                            '.MuiOutlinedInput-input': {
                                height: 30,
                                lineHeight: '32px',
                                paddingLeft: '5px',
                                width: "165px",

                            },
                            '.MuiOutlinedInput-notchedOutline': {
                                border: 'none', // Removes the border
                            },
                        }}>

                        <Typography
                            variant="body2"
                            sx={{

                                color: 'gray',
                                fontWeight: 500,
                                whiteSpace: 'nowrap', // Prevent label from wrapping
                            }}
                        >
                            Sort By
                        </Typography>

                        <Select
                            id="sort"
                            value={sortOption}
                            onChange={handleSortChange}
                            input={<OutlinedInput />}
                            MenuProps={MenuProps}
                            displayEmpty
                        >
                            {sortOptions.map((option) => (
                                <MenuItem key={option.key} value={option.key}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                </div>

            </div>






        </div>
    )



}


export default FilterPanel